export function adjustColorLuminance(hex: string) {
	hex = hex.replace('#', '')

	const r = parseInt(hex.substring(0, 2), 16)
	const g = parseInt(hex.substring(2, 4), 16)
	const b = parseInt(hex.substring(4, 6), 16)
	const luma = (0.2126 * r) + (0.7152 * g) + (0.0722 * b)

	const background = `rgba(${r}, ${g}, ${b}, 0.1)`

	const color = luma >= 98
		? `rgba(${r / 1.7}, ${g / 1.7}, ${b / 1.7}`
		: `rgb(${r}, ${g}, ${b})`

	return { background, color }
}
